import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
// import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useRef } from "react";
import { useMenu } from "../contexts/menuContext";
import { Link } from "react-router-dom";
import "../css/TaimMenuAndScrollMenu.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import { useClickOutside } from "../hooks/useClickOutside";
import MyLink from "@mui/material/Link";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
export default function TamerMenu() {
  const menuRef = useRef(null);
  const { isOpen, closeMenu } = useMenu();

  useClickOutside(menuRef, closeMenu);

  return (
    <div
      ref={menuRef}
      className="tamer-menu"
      style={{
        overflowY: "auto",
        height: "100vh",
        width: "400px",
        backgroundColor: "black",
        position: "fixed",
        top: "0",
        transition: ".3s",
        right: isOpen ? "0" : "-100%",
        // zIndex: "500",
        padding: "30px 10px",
        color: "white",
        zIndex: "1000",
        fontWeight: "normal",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "right",
          marginBottom: "45px",
        }}
      >
        <IconButton
          id="closeMenu"
          onClick={() => closeMenu()}
          style={{ backgroundColor: "#455CE9", padding: "20px" }}
        >
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      </div>
      <Divider
        sx={{
          borderColor: "white",
          color: "white",
          backgroundColor: "white",
        }}
      />
      <div style={{ color: "white", fontSize: "30px", margin: "50px 0" }}>
        <Link to="/">
          <h3
            onClick={closeMenu}
            className="menu-option"
            style={{
              padding: "15px",
              margin: "0 30px",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            Home
          </h3>
        </Link>
        <Link to="/work">
          <h3
            onClick={closeMenu}
            className="menu-option"
            style={{
              padding: "15px",
              margin: "0 30px",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            Work
          </h3>
        </Link>
        <Link to="/about">
          <h3
            onClick={closeMenu}
            className="menu-option"
            style={{
              padding: "15px",
              margin: "0 30px",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            About
          </h3>
        </Link>
        <Link to="/contact">
          <h3
            onClick={() => closeMenu()}
            className="menu-option"
            style={{
              padding: "15px",
              margin: "0 30px",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            Contact
          </h3>
        </Link>
      </div>
      <Divider
        sx={{
          borderColor: "white",
          color: "white",
          backgroundColor: "white",
        }}
      />
      <div style={{ padding: "30px" }}>
        <h4 style={{ letterSpacing: "2px", fontWeight: "normal" }}>
          Contacts :
        </h4>
        <div style={{ margin: "15px 0" }}>
          <ButtonGroup sx={{ width: "100%", color: "white" }}>
            <MyLink
              href="https://www.facebook.com/Taimjr10"
              target="_blank"
              underline="none"
            >
              <Button
                className="socail-btn facebook-btn"
                sx={{ borderColor: "white !important", color: "white" }}
              >
                <FacebookIcon />
              </Button>
            </MyLink>
            <MyLink
              href="https://github.com/Taim-Gr"
              target="_blank"
              underline="none"
            >
              <Button
                className="socail-btn github-btn"
                sx={{ borderColor: "white !important", color: "white" }}
              >
                <GitHubIcon />
              </Button>
            </MyLink>
            <MyLink href="https://wa.me/+963996621746" target="_blank">
              <Button
                className="socail-btn whatsapp-btn"
                sx={{ borderColor: "white !important", color: "white" }}
              >
                <WhatsAppIcon />
              </Button>
            </MyLink>
            <MyLink
              href="https://www.linkedin.com/in/taim-jaber-90621237b/"
              target="_blank"
            >
              <Button
                className="socail-btn linkedin-btn"
                sx={{ borderColor: "white !important", color: "white" }}
              >
                <LinkedInIcon />
              </Button>
            </MyLink>
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}
